package com.milta.core.localization.translations.fr

import com.milta.core.localization.AiCreditStrings

internal val AiCredit = AiCreditStrings(
    aiMark = "IA",
    menuAiLegend = "IA : lecture automatique par l'intelligence artificielle, qui utilise votre crédit IA. Pour Excel, seulement si les colonnes ne sont pas reconnues.",
    menuExhaustedTitle = "Crédit IA épuisé — remise à zéro le {date}.",
    menuExhaustedMessage = "Le scan et l'import PDF sont désactivés. Un tableur aux colonnes attendues et la saisie manuelle restent possibles.",
    modeDisabledReason = "Crédit IA épuisé",
    exhaustedBannerWebTitle = "Crédit IA épuisé — remise à zéro le {date}.",
    exhaustedBannerWebMessage = "Les PDF ne peuvent plus être analysés. Importez un fichier Excel ou CSV aux colonnes attendues, ou ajoutez les livraisons à la main depuis l'application mobile.",
    dropConstraintsWithoutPdf = "Excel (.xlsx, .xls) ou CSV · 500 arrêts max · 10 Mo",
    pdfUnavailableUntil = "PDF indisponible jusqu'au {date}",
    pdfRefusedTitle = "Crédit IA épuisé — ce PDF ne peut pas être analysé",
    pdfRefusedMessage = "« {file} » demande une lecture par l'IA. Votre crédit revient le {date}. D'ici là, importez un fichier Excel ou CSV aux colonnes attendues, ou ajoutez les livraisons à la main depuis l'application mobile.",
    spreadsheetExhaustedTitle = "Colonnes non reconnues — crédit IA épuisé",
    spreadsheetExhaustedWebMessage = "Les colonnes de « {file} » ne correspondent pas aux colonnes attendues, et votre crédit IA ne permet plus de les retrouver automatiquement (retour le {date}). Renommez les colonnes comme ci-dessous, ou ajoutez les livraisons à la main depuis l'application mobile.",
    expectedColumnsNoCreditHint = "Un fichier qui respecte ces colonnes est importé sans IA et ne consomme pas de crédit, même à 0 %.",
    importExhaustedTitle = "Crédit IA épuisé",
    importExhaustedPhotoMessage = "Votre crédit IA est arrivé à 0 % pendant que cet import attendait. La photo n'a pas été analysée et rien n'a été décompté. Remise à zéro le {date}.",
    importExhaustedFileMessage = "Votre crédit IA est arrivé à 0 % pendant que cet import attendait. Le fichier n'a pas été analysé et rien n'a été décompté. Remise à zéro le {date}.",
    importSpreadsheetExhaustedMessage = "Les colonnes de ce fichier ne correspondent pas aux colonnes attendues, et votre crédit IA ne permet plus de les retrouver automatiquement. Remise à zéro le {date}.",
    stepPhotoSent = "Photo envoyée",
    stepFileSent = "Fichier envoyé : {file}",
    stepAnalysisNotStarted = "Analyse non lancée : crédit IA épuisé",
    stepFileRead = "Fichier lu : {file}",
    stepExpectedColumns = "Colonnes attendues : Nom du destinataire, Adresse complète",
    stepDeliveriesKept = "Livraisons déjà saisies conservées",
    retryAvailableOn = "Réessayer — disponible le {date}",
    manualEntryAction = "Saisie manuelle",
    myUsageTitle = "Mon usage",
    myUsageAttachedDriverNote = "Seules vos propres actions apparaissent ici. Ce que vos Entreprises lancent pour vous est décompté chez elles.",
    tabOptimizations = "Optimisations",
    tabAiCredit = "Crédit IA",
    remainingForPeriod = "Crédit IA restant pour la période",
    percentValue = "{percent} %",
    remainingSuffix = "de crédit IA restant",
    lowPill = "Crédit bas",
    exhaustedPill = "Épuisé · scan et import PDF désactivés",
    driverNote = "Votre crédit revient au renouvellement de l'abonnement (celui de votre Entreprise si vous en faites partie). Le crédit non utilisé n'est pas reporté.",
    enterpriseNote = "Revient au renouvellement de votre abonnement, sans report. Ce crédit ne concerne que vos actions IA ; chaque chauffeur a le sien.",
    exhaustedNote = "La saisie manuelle et les tableurs aux colonnes attendues restent disponibles. Le crédit revient au renouvellement de votre abonnement.",
    webScopeHint = "Ce crédit ne concerne que les actions IA de ce compte : scans, imports PDF ou photo, colonnes de tableur non reconnues. Chaque chauffeur a le sien.",
    profileValue = "{optimizations} · IA {percent} %",
    profileValueAiOnly = "IA {percent} %",
    columnShare = "Part du crédit",
    actionScanDeliveryList = "Scan de liste",
    actionScanPackageLabel = "Scan d'étiquette",
    actionImportPdf = "Import PDF",
    actionImportUnstructured = "Import en tâche de fond",
    actionSpreadsheetMapping = "Colonnes de tableur (IA)",
    outcomeSuccess = "Réussi",
    outcomeFailed = "Échec",
    outcomeUnreadable = "Illisible",
    countedSuffix = "(décompté)",
    rowDateTime = "{date} à {time}",
    limitsEyebrow = "Crédit IA par période",
    limitsDescription = "Montant en euros que chaque compte peut consommer en appels IA (scans, imports PDF ou photo, colonnes de tableur non reconnues) par période d'abonnement. Le crédit revient à la limite au renouvellement de l'abonnement, sans report.",
    weightedEquivalent = "≈ {tokens} tokens pondérés",
    limitsFootnote = "Un chauffeur d'Entreprise reçoit la limite « Chauffeur », en essai tant que son Entreprise est en essai. L'équivalent en tokens est affiché à titre indicatif et se recalcule avec le taux ci-dessous.",
    conversionEyebrow = "Conversion et alerte",
    rateLabel = "Taux de change",
    rateHint = "Mis à jour à la main · s'applique aux appels suivants",
    thresholdLabel = "Alerte crédit bas",
    thresholdUnit = "% restant",
    thresholdHint = "Pourcentage en orange et bannière une fois par période",
    calculationTitle = "Comment le coût d'un appel est calculé.",
    calculationBody = "Claude Haiku 4.5 : 1 $ par million de tokens d'entrée, 5 $ par million de tokens de sortie. Token pondéré = entrée × 1 + sortie × 5, donc 1 $ = 1 000 000 tokens pondérés. Coût en euros = coût en dollars ÷ taux. Exemple : un scan de liste moyen (5 014 entrée + 1 792 sortie) = 13 974 tokens pondérés = 0,014 $ ≈ 0,013 €.",
    settingsSavedTitle = "Limites enregistrées.",
    settingsSavedDetail = "Entreprise : {enterpriseTrial} essai · {enterprisePaid} payant. Chauffeur : {driverTrial} essai · {driverPaid} payant. Taux {rate}. Alerte {threshold} %.",
    limitTooHigh = "Maximum 1 000 €.",
    rateTooHigh = "Maximum 10.",
    thresholdOutOfRange = "Entre 1 et 99.",
    adminCreditTitle = "Crédit IA",
    adminRemainingLine = "≈ {tokens} tokens pondérés restants · consommé {consumed}",
    adminOverrunLine = "Consommé {consumed} · dépassement de {over}",
    adminLowPill = "Crédit bas · sous {threshold} %",
    adminLowPillNoThreshold = "Crédit bas",
    adminExhaustedPill = "Crédit épuisé · actions IA désactivées",
    adminAppliedAfterReplacement = "{consumed} consommés + {remaining} restants (remplacement)",
    adminGlobalLimitLabel = "Limite globale",
    adminGlobalLimitResumes = "{source} — reprise à la remise à zéro",
    adminResetNoCarryOver = "Repart à {limit} : le dépassement n'est pas reporté",
    replaceLabel = "Remplacer le crédit restant",
    replaceHelp = "De 0 à 100 €, pour la période en cours uniquement. À la remise à zéro, le compte repart de la limite globale.",
    replaceHelpEnterpriseDriver = "Ne modifie que le crédit de {name}. Celui de l'Entreprise et des autres chauffeurs ne change pas.",
    replaceInvalid = "Saisissez un montant de 0 à 100 €.",
    replacedTitle = "Crédit restant remplacé : {from} → {to}.",
    replacedDetail = "Pour la période en cours. Le {date}, retour à la limite globale ({limit}).",
    adminHistoryTitle = "Historique du crédit IA",
    adminPeriodSummary = "Période en cours depuis le {start} : {calls} appels · {failed} en échec ou illisible (décomptés) · {tokens} tokens pondérés · {consumed}",
    columnInput = "Entrée",
    columnOutput = "Sortie",
    columnWeighted = "Pondérés",
    columnCost = "Coût",
    decimalSeparator = ",",
    importExhaustedNeutralMessage = "Votre crédit IA est épuisé. Le fichier n'a pas été analysé et rien n'a été décompté. Remise à zéro le {date}.",
    rateUnitPrefix = "1 € =",
    rateUnitSuffix = "\$",
)
